export default __webpack_public_path__ + "static/media/large-logo.32343370.png";